import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IHobby {
  id: number
  title: string
  status: number
  code: string
}
export interface IHobbyEdit {
  id: number
  title: string
  status: number
  code: string
}
// danh sách sở thích khách hàng
export const gListHobby = async (limit?: number, pageNumber?: number, search?: string) => {
  const path = "hobby/listHobby"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<IHobby[]> = await axiosClient.get(
    path, { params }
  )
  return result
};

// thông tin sở thích
export const gInfoHobby = async (id: number) => {
  const path = "hobby/infoHobby"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IHobbyEdit> = await axiosClient.get(
    path, { params }
  )
  return result
}
//thêm sở thích
export const addHobby = async (code: string, title: string, status: number) => {
  const path = "hobby/addHobby"
  const params = {
    code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  )
  return result
}
// chỉnh sửa sở thích
export const editHobby = async (id: number, code: string, title: string, status: number) => {
  const path = "hobby/editHobby"
  const params = {
    id, code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
// xóa sở thích
export const deleteHobby = async (id: number) => {
  const path = "hobby/deleteHobby"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  )
  return result
}
// cập nhật trạng thái sở thích
export const updateStatusHobby = async (id: number) => {
  const path = "hobby/activeHobby"

  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
